// extracted by mini-css-extract-plugin
export default {"leftSide":"LoginLeftSide_leftSide__0RLLJ","logo":"LoginLeftSide_logo__DWv5j","imgtextcontainer":"LoginLeftSide_imgtextcontainer__a0naW"};